// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"40f548f5","453":"25322ed1"}[chunkId] + ".chunk.js");